// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FWEJ","content":"styles_content__38JxQ"};